/**
 * 当用户禁用第三方网站cookie时，或localStorage/sessionStorage不可用时，自动使用内存存储作为替代方案
 *
 */

// localStorage是否可用
function isLocalStorageAvailable() {
    try {
        const localStorage = window.localStorage;
        const test = 'st_test';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

// sessionStorage是否可用
function isSessionStorageAvailable() {
    try {
        const sessionStorage = window.sessionStorage;
        const test = 'st_test';
        sessionStorage.setItem(test, test);
        sessionStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

// storage替代方法
class MemoryStorage {
    constructor() {
        this.storage = {};
    }

    getItem(key) {
        return this.storage[key] || null;
    }

    setItem(key, value) {
        this.storage[key] = value;
    }

    removeItem(key) {
        delete this.storage[key];
    }
}

// localStorage使用
let localStorage = isLocalStorageAvailable() ?  window.localStorage : new MemoryStorage();

// sessionStorage使用
let sessionStorage = isSessionStorageAvailable() ? window.sessionStorage :   new MemoryStorage();

export  {
    localStorage,
    sessionStorage,
};
